module.exports = __webpack_public_path__ + "static/img/torso14.01c75cc5.jpg";